import Swal from "sweetalert2";
export const findCode_paging = async (endOf_time, promo_code, typePromo_code, releaseCode, promo_id, user_used, ip, status_code, code_send, page, limit) => {
  if (promo_code !== "" && promo_code !== undefined) {
    promo_code = "&promo_code=" + promo_code;
  }
  if (releaseCode !== "" && releaseCode !== undefined) {
    releaseCode = "&releaseCode=" + releaseCode;
  }
  if (promo_id !== "" && promo_id !== undefined) {
    promo_id = "&promo_id=" + promo_id;
  }
  if (user_used !== "" && user_used !== undefined) {
    user_used = "&user_used=" + user_used;
  }
  if (ip !== "" && ip !== undefined) {
    ip = "&ip=" + ip;
  }

  if (status_code !== "" && status_code !== undefined) {
    status_code = "&status_code=" + status_code;
  }
  if (endOf_time !== 0 && endOf_time !== undefined) {
    endOf_time = "&endOf_time=" + endOf_time;
  }
  if (code_send !== "" && code_send !== undefined) {
    code_send = "&code_send=" + code_send;
  }

  function bouncer(arr) {
    return arr.filter(Boolean);
  }

  let newArray = bouncer([promo_code, releaseCode, promo_id, user_used, ip, endOf_time, code_send, status_code]);
  function removeItemAll(arr, value) {
    let i = 0;
    while (i < arr.length) {
      if (arr[i] === value) {
        arr.splice(i, 1);
      } else {
        ++i;
      }
    }
    return arr;
  }

  let findCodeArray = removeItemAll(newArray, "default");

  let endPoint =
    localStorage.getItem("endpoint-redeem") +
    "/code/find?site=" +
    localStorage.getItem("site-redeem") +
    "&typePromo_code=" +
    typePromo_code?.value +
    "&limit=" +
    limit +
    "&page=" +
    (page + 1);
  findCodeArray.forEach((el) => {
    endPoint = endPoint + el;
  });
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return await fetch(endPoint, requestOptions)
    .then((response) => response.json())
    .then(async (result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Không tải được dữ liệu", "warning");
    });
};

export const findCode_v2 = async (data) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(data);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  return await fetch(localStorage.getItem("endpoint-redeem") + "/code/find?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then(async (result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Không tải được dữ liệu", "warning");
    });
};

export const findCode_download = async (data) => {
  let body = Object.fromEntries(Object.entries(data).filter(([_, v]) => v !== null && v !== 0 && v !== ""));

  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(body);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const { total, status_code } = await fetch(
      localStorage.getItem("endpoint-redeem") + "/export/count?site=" + localStorage.getItem("site-redeem"),
      requestOptions
    )
      .then((response) => response.json())
      .then(async (result) => {
        return result;
      })
      .catch((error) => {
        console.log("error", error);
        return 500;
      });
    if (status_code === 200 && total > 0) {
      const size = 50000;
      let page = 0;
      const totalpage = Math.ceil(total / size);
      while (page < totalpage) {
        let requestOptions2 = {
          method: "POST",
          headers: myHeaders,
          body: raw,
        };
        const response = await fetch(
          localStorage.getItem("endpoint-redeem") + "/export?site=" + localStorage.getItem("site-redeem") + "&page=" + page + "&size=" + size,
          requestOptions2
        );
        if (!response.ok) {
          throw new Error(`Lỗi ${response.status}: ${response.statusText}`);
        }
        const blob = await response.blob();
        // Tạo một đường link ẩn để tải file
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `FreeCode-${localStorage.getItem("site-redeem").toUpperCase()}_${data?.type}${page + 1}_${Math.ceil(totalpage)}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        page++;
      }
      return status_code;
    } else {
      return 404;
    }
  } catch (error) {
    console.error("Lỗi tải file:", error);
  }
};


export const resetCode = async (promo_code) => {
  try {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ promo_code });

    const response = await fetch(
      localStorage.getItem("endpoint-redeem") +
        "/code/reset?site=" +
        localStorage.getItem("site-redeem"),
      {
        method: "POST",
        headers: myHeaders,
        body,
      }
    );

    const result = await response.json();

    if (result.code === 200) {
      Swal.fire("สำเร็จ", "Reset promo code เรียบร้อย", "success");
      return result;
    } else {
      Swal.fire("ผิดพลาด", result.mess || "Reset ไม่สำเร็จ", "warning");
      return result;
    }
  } catch (error) {
    console.error("resetCode error:", error);
    Swal.fire("ล้มเหลว", "ไม่สามารถเชื่อมต่อระบบได้", "error");
  }
};
